import Modal from "./Modal";
const axios = require('axios').default;

class DonationForm {

    BraintreeHostedfieldsInstance: any;
    BraintreePaypalCheckoutInstance: any;
    BraintreeGooglePaymentInstance: any;
    BraintreeApplePayInstance: any;
    BraintreeApplePayEventListener: any;
    BraintreeFormSubmitFunction: any;
    BraintreeTransactionData: any;
    donationBlocks: NodeListOf<HTMLElement>;
    donationForm: NodeListOf<HTMLElement>;
    donationAmount: number;
    donationType: string;
    countryCode: string;
    giftAmount: string;
    giftAidIncrease: number;
    giftAidAmount: number;
    isBraintreeForm: boolean;
    formStep1: HTMLElement;
    formStep2: HTMLElement;
    formStep3: HTMLElement;
    stepNavs: NodeListOf<HTMLElement>;
    formStep: number;
    totalSteps: number;
    requiredInputs: NodeListOf<HTMLInputElement>;
    modal: Modal;
    KEYCODE_ESC: number;
    worldPayContainer: HTMLElement;
    worldPayIframeContainer: HTMLElement;
    worldPayLibraryObject: any;
    form: HTMLFormElement;
    openButtons: NodeList;
    stickyDonation: any;
    additionalDonate: any;
    isMobileDevice: boolean;
    isDevHost: boolean;
    splitPayment: boolean;
    totalSplitPaymentAmount: string;
    captchaReady: HTMLFormElement;
    showPaypal: HTMLFormElement;
    apayContainer: HTMLElement;
    gaVars: object;

    constructor() {

        this.BraintreeHostedfieldsInstance = null;
        this.BraintreePaypalCheckoutInstance = null;
        this.BraintreeGooglePaymentInstance = null;
        this.BraintreeApplePayInstance = null;
        this.BraintreeApplePayEventListener = null;
        this.BraintreeFormSubmitFunction = null;
        this.BraintreeTransactionData = null;
        this.donationBlocks = document.querySelectorAll('.stepped-donation-block');
        this.donationForm = document.querySelectorAll('.acc-donation-form');
        this.donationAmount = 0;
        this.donationType = null;
        this.countryCode = "GB";
        this.giftAmount = '0';
        this.isBraintreeForm = false;
        this.formStep = 1;
        this.totalSteps = 3;
        this.modal = new Modal();
        this.KEYCODE_ESC = 27;
        this.openButtons = document.querySelectorAll('[data-modal-target]');
        this.stickyDonation = document.querySelector('.sticky_donate');
        this.additionalDonate = document.querySelector('#donate_interaction');
        this.isMobileDevice = false;
        this.isDevHost = false;
        this.apayContainer = document.querySelector('#applePayWrapper');
        this.gaVars = {};

        //this.captchaReady = document.querySelector('#gcReady');
        this.splitPayment = false;
        this.totalSplitPaymentAmount = '0.00';
        this.showPaypal = document.querySelector('#showPaypal');
    }

    // Check if the donation block should be able to handle split payments
    isSplitPayment(donationBlock) {
        const input = donationBlock.querySelector('[name="is-split-payment"]');

        return input !== null
    }

    init() {

        var _this = this

        setTimeout(function () {
            _this.isMobileDevice = (<any>window).Crisis.util.isMobileDevice;
            _this.isDevHost = (<any>window).Crisis.util.isDevHost;
        }, 1000);

        if (this.donationBlocks.length > 0) {
            Array.prototype.forEach.call(this.donationBlocks, donationBlock => {
                const isSplitPayment = this.isSplitPayment(donationBlock);
                const donateButtons = isSplitPayment ? donationBlock.querySelectorAll('.donate-button, .split-donate-button') : donationBlock.querySelectorAll('.donate-button');
                if (donateButtons !== null) {
                    Array.prototype.forEach.call(donateButtons, donateButton => {
                        donateButton.addEventListener('click', async () => {
                            if (isSplitPayment) {
                                if (donateButton.dataset.splitValue) {
                                    this.showPaypal.classList.add('hidden');
                                    this.splitPayment = true;
                                    this.totalSplitPaymentAmount = donateButton.dataset.splitValue
                                } else {
                                    this.splitPayment = false;
                                    this.showPaypal.classList.remove('hidden');
                                }
                            }

                            this.donationAmount = Number(donateButton.value);
                            this.giftAmount = donateButton.dataset.giftAmount;
                            this.giftAidIncrease = Number(this.donationAmount * 0.25);
                            this.giftAidAmount = Number(this.donationAmount * 1.25);
                            var target = donateButton.dataset.modalTarget;
                            var targetFormContainer = document.querySelector(`#${target}`);

                            this.gaVars = {
                                productSku: targetFormContainer.getAttribute('data-product-sku'),
                                productName: targetFormContainer.getAttribute('data-product-name'),
                                productCategory: targetFormContainer.getAttribute('data-product-category')
                            }

                            // take this out of typescript and add on view if needed
                            //     this.loadCaptcha(); 

                            if (targetFormContainer != null) {
                                this.form = targetFormContainer.querySelector('form');
                                if (this.splitPayment) {
                                    this.form.setAttribute('data-is-split-payment', 'true')
                                } else {
                                    this.form.removeAttribute('data-is-split-payment');
                                }
                                this.loadForm(this.form, target)
                                if (this.form !== null) {
                                    this.updateFormDonationAmounts(this.form);
                                }
                                //var whichFormType = target.replace('-', ' ');
                                this.updateGoogleAnalyticsCart(this.gaVars, this.donationAmount);
                            }

                            else {
                                console.log("gc script not loaded");
                            }
                        });
                    });
                }
            });
            document.addEventListener('onDonationModalShowStep', () => {
                this.pushToDataLayer();
            });
            document.addEventListener('doSubmitPaymentModalForm', () => {
                this.submitForPayment(this.form);
            });
        }

        if (this.stickyDonation || this.additionalDonate) {
            const donateContainer = this.stickyDonation ? this.stickyDonation : this.additionalDonate;
            const amountInput = donateContainer.querySelector('#amountModalValue');
            const btn = donateContainer.querySelector('#donate_once, #confirm_donate_once');
            btn.addEventListener('click', () => {
                this.donationAmount = Number(amountInput.value);
                this.giftAidAmount = this.donationAmount * 1.25;

                var target = btn.dataset.modalTarget;
                var targetFormContainer = document.querySelector(`#${target}`);

                if (targetFormContainer != null) {
                    this.form = targetFormContainer.querySelector('form');
                    this.loadForm(this.form, target)
                    if (this.form !== null) {
                        this.updateFormDonationAmounts(this.form);
                    }
                }
            });

            const btnReg = donateContainer.querySelector('#donate_monthly, #confirm_donate_monthly');
            btnReg.addEventListener('click', () => {
                this.donationAmount = Number(amountInput.value);
                this.giftAidAmount = this.donationAmount * 1.25;

                var target = btnReg.dataset.modalTarget;
                var targetFormContainer = document.querySelector(`#${target}`);

                if (targetFormContainer != null) {
                    this.form = targetFormContainer.querySelector('form');
                    this.loadForm(this.form, target)
                    if (this.form !== null) {
                        this.updateFormDonationAmounts(this.form);
                    }
                }
            });
            document.addEventListener('onDonationModalShowStep', () => {
                this.pushToDataLayer();
            });
            document.addEventListener('doSubmitPaymentModalForm', () => {
                this.submitForPayment(this.form);
            });
        }
    }

    updateGoogleAnalyticsCart(gaVars, donationAmount, evt = 'add_to_cart') {
        window.dataLayer = window.dataLayer || [];
        if (window.dataLayer) {
            window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            window.dataLayer.push({
                event: evt,
                currency: 'GBP',
                ecommerce: {
                    items: [
                        {
                            item_id: gaVars.productSku,
                            item_name: gaVars.productName,
                            affiliation: 'Crisis',
                            currency: 'GBP',
                            index: 0,
                            item_brand: 'Crisis',
                            item_category: gaVars.productCategory,

                            price: donationAmount,
                            quantity: 1
                        }
                    ]
                }
            })
        }
    }

    loadForm(form, targetId) {

        if (form !== null) {
            let theTotalSteps = form.querySelectorAll('.acc-modal').length + 1;
            if (document.querySelector('.acc-donation-form-container.rd-donation-form')) {
                theTotalSteps -= 1;
            }
            this.totalSteps = theTotalSteps;
            this.isBraintreeForm = form.querySelectorAll('[name="btree-flag"]').length ? true : false;

            this.formStep1 = form.querySelector(`[data-modal=${targetId + "1"}]`)
            this.formStep2 = form.querySelector(`[data-modal=${targetId + "2"}]`)
            this.formStep3 = form.querySelector(`[data-modal=${targetId + "3"}]`)
            this.worldPayContainer = document.querySelector('#wp-container');
            this.worldPayIframeContainer = form.querySelector('#wp-iframe-container');
            const typeOfDonationInput: HTMLInputElement = this.formStep1.querySelector('[name="donationType"]');
            const countryCodeInput: HTMLInputElement = this.formStep1.querySelector('[name="CountryCode"]');
            // const addressSelect = document.getElementsByClassName("address-results");
            const giftOnBehalfInput: HTMLInputElement = this.formStep2.querySelector('[name="donateOnBehalf"]');
            const raisedByInput: HTMLInputElement = this.formStep2.querySelector('[name="raisedBy"]');
            const personalDetailsWrapper = this.formStep2.querySelector('.personal-details-wrapper');
            const ecardDetailsWrapper = personalDetailsWrapper != null ? personalDetailsWrapper.querySelector('.ecard-details-wrapper') : null;
            const recipientRadios: NodeListOf<HTMLInputElement> = ecardDetailsWrapper != null ? ecardDetailsWrapper.querySelectorAll('input[type="radio"]') : null;
            const recipientDetailsWrapper = ecardDetailsWrapper != null ? ecardDetailsWrapper.querySelector('.recipient-details') : null;
            const recipientEmailWrapper = recipientDetailsWrapper != null ? recipientDetailsWrapper.querySelector('.recipient-email') : null;
            this.stepNavs = form.querySelectorAll('.donation-steps-nav');
            this.requiredInputs = form.querySelectorAll('[data-val-required]');
            const modalCloseBtns = form.querySelectorAll('[data-modal-close]');
            const navStepBtns = form.querySelectorAll('.nav-step-cta');
            const orgCopyDetailsInput: HTMLInputElement = form.querySelector('[name="useOrgContactForCardholder"]');
            const modalRestartBtns = form.querySelectorAll('[data-val-restart]');
            const previousStepBtns = form.querySelectorAll('.previous-step');
            const reviewDetails = form.querySelector('#reviewDetails');
            const progressivePhoneConsent = document.querySelector('#progConsentPhone');
            const telephoneNumberInput: HTMLInputElement = form.querySelector('input[type="tel"][name="phoneNumber"]');
            const IsChristmas = form.querySelector('[name="IsChristmas"]');
            const inputIsSplitPayment = form.querySelector("[name='IsSplitPayment']");
            const inputIsRecurringPayment = form.querySelector("[name='IsRecurringPayment']");
            const inputTotalSplitPaymentAmount = form.querySelector("[name='TotalSplitPaymentAmount']");

            if (inputIsSplitPayment) {
                inputIsSplitPayment.value = false;
            }

            if (inputIsRecurringPayment) {
                inputIsRecurringPayment.value = false;
            }

            if (inputTotalSplitPaymentAmount) {
                inputTotalSplitPaymentAmount.value = '0.00';
            }

            const modalIntroSingle: HTMLElement = document.querySelector('.donation-modal-intro--single');
            const modalIntroSplit: HTMLElement = document.querySelector('.donation-modal-intro--split');
            const modalAmountSingle: HTMLElement = document.querySelector('.donation-modal-amount--single');
            const modalAmountSplit: HTMLElement = document.querySelector('.donation-modal-amount--split');

            //if (!this.splitPayment) {
            //    modalAmountSplit.classList.add('hidden');
            //    modalAmountSplit.hidden = true;
            //}

            if (this.splitPayment) {
                if (modalIntroSingle) {
                    modalIntroSingle.hidden = true;
                }
                if (modalIntroSplit) {
                    modalIntroSplit.hidden = false;
                }
                if (modalAmountSingle) {
                    modalAmountSingle.hidden = true;
                }
                if (modalAmountSplit) {
                    modalAmountSplit.hidden = false;
                    modalAmountSplit.classList.remove('hidden');
                }
            } else {
                if (modalIntroSingle) {
                    modalIntroSingle.hidden = false;
                }
                if (modalIntroSplit) {
                    modalIntroSplit.hidden = true;
                }
                if (modalAmountSingle) {
                    modalAmountSingle.hidden = false;
                }
                if (modalAmountSplit) {
                    modalAmountSplit.hidden = true;
                    modalAmountSplit.classList.add('hidden');
                }
            }

            if (reviewDetails) {
                reviewDetails.addEventListener('click', (e) => {
                    e.preventDefault();
                    //document.addEventListener('click', event => {
                    //    const escPressed = event.keyCode === this.KEYCODE_ESC;

                    const accountNameInput: HTMLInputElement = form.querySelector('#accountName');
                    const address1Input: HTMLInputElement = form.querySelector('[name="addressLine1"]');
                    const address2Input: HTMLInputElement = form.querySelector('[name="addressLine2"]');
                    const address3Input: HTMLInputElement = form.querySelector('[name="addressLine3"]');
                    const cityInput: HTMLInputElement = form.querySelector('[name="city"]');
                    const postalCodeInput: HTMLInputElement = form.querySelector('[name="postalCode"]');
                    const accountNumberInput: HTMLInputElement = form.querySelector('[name="accountNumber"]');
                    const bankNameInput: HTMLInputElement = form.querySelector('[name="bankName"]');
                    const branchNameInput: HTMLInputElement = form.querySelector('[name="branchName"]');
                    const sc1Input: HTMLSelectElement = form.querySelector('[name="sc1"]');
                    const sc2Input: HTMLSelectElement = form.querySelector('[name="sc2"]');
                    const sc3Input: HTMLSelectElement = form.querySelector('[name="sc3"]');
                    const firstDayInput: HTMLSelectElement = form.querySelector('[name="firstPaymentDay"]');
                    const firstMonthInput: HTMLSelectElement = form.querySelector('[name="firstPaymentMonth"]');
                    const firstYearInput: HTMLSelectElement = form.querySelector('[name="firstPaymentYear"]');
                    const paymentFrequencyInput: HTMLSelectElement = form.querySelector('[name="paymentFrequency"]');
                    const amountInput: HTMLInputElement = form.querySelector('[name="amount"]');

                    this.formStep3.querySelector('#confAccountName').innerHTML = accountNameInput.value;
                    this.formStep3.querySelector('#confAddress1').innerHTML = address1Input.value;
                    this.formStep3.querySelector('#confAddress2').innerHTML = address2Input.value;
                    this.formStep3.querySelector('#confAddress3').innerHTML = address3Input.value;
                    this.formStep3.querySelector('#confCity').innerHTML = cityInput.value;
                    this.formStep3.querySelector('#confPostalCode').innerHTML = postalCodeInput.value;
                    this.formStep3.querySelector('#confAccountNumber').innerHTML = accountNumberInput.value;
                    this.formStep3.querySelector('#confBank').innerHTML = bankNameInput.value;
                    this.formStep3.querySelector('#confBranchName').innerHTML = branchNameInput.value;
                    this.formStep3.querySelector('#confSort1').innerHTML = sc1Input.value;
                    this.formStep3.querySelector('#confSort2').innerHTML = sc2Input.value;
                    this.formStep3.querySelector('#confSort3').innerHTML = sc3Input.value;
                    this.formStep3.querySelector('#confFirstDay').innerHTML = firstDayInput.value;
                    this.formStep3.querySelector('#confFirstMonth').innerHTML = firstMonthInput.value;
                    this.formStep3.querySelector('#confFirstYear').innerHTML = firstYearInput.value;
                    this.formStep3.querySelector('#confFrequency').innerHTML = paymentFrequencyInput.value;
                    this.formStep3.querySelector('#confAmount').innerHTML = amountInput.value;

                });
            }

            if (progressivePhoneConsent !== null) {
                telephoneNumberInput.addEventListener('input', () => {
                    if (telephoneNumberInput.value && telephoneNumberInput.value.length > 5) {
                        progressivePhoneConsent.classList.remove('is-d-none');
                    } else {
                        progressivePhoneConsent.classList.add('is-d-none');
                    }
                });
            }

            if (modalCloseBtns.length > 0) {
                Array.prototype.forEach.call(modalCloseBtns, closeBtn => {
                    closeBtn.addEventListener('click', () => {
                        this.resetForm(form);
                    });
                });

                document.addEventListener('keydown', event => {
                    const escPressed = event.keyCode === this.KEYCODE_ESC;

                    if (!escPressed) return;

                    if (escPressed) {
                        this.resetForm(form);
                    }
                });
            }


            if (modalRestartBtns.length) {
                Array.prototype.forEach.call(modalRestartBtns, btn => {
                    btn.addEventListener('click', () => {
                        this.formStep = 1;
                        this.scrollFormBackToTop(form);

                        if (this.worldPayContainer)
                            this.worldPayContainer.innerHTML = '';

                        Array.prototype.forEach.call(document.querySelectorAll('.common-error-container'), ele => {
                            ele.classList.add('is-d-none')
                        });

                        this.modal.show(`${targetId + "1"}`, true, this.formStep);
                        this.modal.hide(`${targetId + "2"}`, true);
                        this.modal.hide(`${targetId + "3"}`, true);

                        this.hideValidationMessages(this.requiredInputs);
                    });
                });
            }

            if (typeOfDonationInput.value === "org") {
                Array.prototype.forEach.call(this.stepNavs, stepNav => {
                    const detailsStep = stepNav.querySelectorAll('li')[0];
                    const previousStepCta = detailsStep.querySelector('.previous-step');
                    const stepText = "1. Organisation details";

                    if (previousStepCta !== null) {
                        previousStepCta.textContent = stepText;
                    } else {
                        detailsStep.textContent = stepText;
                    }
                });

                if (this.formStep1) {
                    this.formStep1.querySelector('.org-title').classList.remove('is-d-none');
                    this.formStep1.querySelector('.org-details').classList.remove('is-d-none');

                    Array.prototype.forEach.call(this.formStep1.querySelectorAll('.org-field'), field => {
                        field.classList.remove('is-d-none');
                    });
                } else {
                    this.form.querySelector('.org-title').classList.remove('is-d-none');
                    this.form.querySelector('.org-details').classList.remove('is-d-none');
                    Array.prototype.forEach.call(this.form.querySelectorAll('.org-field'), field => {
                        field.classList.remove('is-d-none');
                    });

                }
            }

            typeOfDonationInput.addEventListener('change', () => {

                const giftAidEl = form.querySelector('.gift-aid-container');
                const giftAidCheckBox = giftAidEl.querySelector('input');
                this.donationType = typeOfDonationInput.value;

                //Set Gift Aid message
                this.setGiftAidMessage()

                if (this.donationType === 'christmas') {
                    window.location.href = '/get-involved/make-it-crisis-this-christmas-pay-in/';
                }
                else if (this.donationType === "personal") {
                    giftAidEl.classList.remove('is-d-none');
                    giftAidEl.classList.add('is-d-block');
                    raisedByInput.classList.add('is-d-none');
                    console.log(IsChristmas.value, 'xmas value')
                    //
                    Array.prototype.forEach.call(this.stepNavs, stepNav => {
                        const detailsStep = stepNav.querySelectorAll('li')[0];
                        const detailsStep2 = stepNav.querySelectorAll('li')[1];

                        const stepText = "1. Personal details";
                        const stepText2 = "2. Gift Aid";
                        detailsStep.textContent = stepText;

                        detailsStep2.textContent = stepText2

                    });
                }

                else {
                    giftAidCheckBox.checked = false;
                    giftAidEl.classList.remove('is-d-block');
                    giftAidEl.classList.add('is-d-none');
                    //   personalDetailsWrapper.classList.add('is-d-none');
                    raisedByInput.classList.remove('is-d-none');
                }

                if (this.donationType === "org") {
                    Array.prototype.forEach.call(this.stepNavs, stepNav => {
                        const detailsStep = stepNav.querySelectorAll('li')[0];
                        const detailsStep2 = stepNav.querySelectorAll('li')[1];

                        const navStepCta = detailsStep.querySelector('.nav-step-cta');
                        const stepText = "1. Organisation details";
                        const stepText2 = "2. Keeping in touch";

                        detailsStep2.textContent = stepText2

                        if (navStepCta !== null) {
                            navStepCta.textContent = stepText;
                        } else {
                            detailsStep.textContent = stepText;
                        }
                    });

                    if (this.formStep1) {

                        this.formStep1.querySelector('.org-title').classList.remove('is-d-none');
                        this.formStep1.querySelector('.org-details').classList.remove('is-d-none');
                        Array.prototype.forEach.call(this.formStep1.querySelectorAll('.org-field'), field => {
                            field.classList.remove('is-d-none');
                        });
                    } else {
                        this.form.querySelector('.org-title').classList.remove('is-d-none');
                        this.form.querySelector('.org-details').classList.remove('is-d-none');
                        Array.prototype.forEach.call(this.form.querySelectorAll('.org-field'), field => {
                            field.classList.remove('is-d-none');
                        });
                    }

                }

                else if (this.donationType === "collection") {
                    Array.prototype.forEach.call(this.stepNavs, stepNav => {
                        const detailsStep = stepNav.querySelectorAll('li')[0];
                        const detailsStep2 = stepNav.querySelectorAll('li')[1];

                        const navStepCta = detailsStep.querySelector('.nav-step-cta');
                        const stepText = "1. Personal details";
                        const stepText2 = "2. Keeping in touch";

                        detailsStep2.textContent = stepText2

                        if (navStepCta !== null) {
                            navStepCta.textContent = stepText;
                        } else {
                            detailsStep.textContent = stepText;
                        }

                        if (this.formStep1) {

                            this.formStep1.querySelector('.org-title').classList.add('is-d-none');
                            this.formStep1.querySelector('.org-details').classList.add('is-d-none');
                            Array.prototype.forEach.call(this.formStep1.querySelectorAll('.org-field'), field => {
                                field.classList.add('is-d-none');
                            });
                        } else {
                            this.form.querySelector('.org-title').classList.add('is-d-none');
                            this.form.querySelector('.org-details').classList.add('is-d-none');
                            Array.prototype.forEach.call(this.form.querySelectorAll('.org-field'), field => {
                                field.classList.add('is-d-none');
                            });
                        }
                    });
                }

                else {
                    this.resetFormContent();
                }
            });

            //Country select changed
            countryCodeInput.addEventListener('change', () => {
                this.countryCode = countryCodeInput.value;
                const notGbMessage = this.form.querySelector('.not-gb-message');
                const giftAidEl = this.form.querySelector('.gift-aid-container');
                const giftAidCheckBox = giftAidEl.querySelector('input');

                if (this.donationType === "personal") {
                    giftAidEl.classList.remove('is-d-none');
                    giftAidEl.classList.add('is-d-block');
                    raisedByInput.classList.add('is-d-none');
                    console.log(IsChristmas.value, 'xmas value')

                    if (this.countryCode === "GB") {
                        notGbMessage.classList.add('is-d-none');
                        notGbMessage.classList.remove('is-d-block');
                    }


                    if (IsChristmas.value == "true" && personalDetailsWrapper != null) {
                        personalDetailsWrapper.classList.remove('is-d-none');
                    }
                } else {
                    giftAidCheckBox.checked = false;
                    giftAidEl.classList.remove('is-d-block');
                    giftAidEl.classList.add('is-d-none');

                    if (personalDetailsWrapper != null)
                        personalDetailsWrapper.classList.add('is-d-none');

                    if (raisedByInput != null)
                        raisedByInput.classList.remove('is-d-none');

                    //notGbMessage.classList.remove('is-d-none');
                    //notGbMessage.classList.add('is-d-block');
                }
                this.setGiftAidMessage();
            });

            if (giftOnBehalfInput != null) {

                giftOnBehalfInput.addEventListener('change', () => {

                    if (giftOnBehalfInput.value === "true") {
                        ecardDetailsWrapper.classList.remove('is-d-none');
                    } else {
                        ecardDetailsWrapper.classList.add('is-d-none');
                    }
                });

                Array.prototype.forEach.call(recipientRadios, radio => {
                    radio.addEventListener('change', () => {
                        recipientDetailsWrapper.classList.remove('is-d-none');

                        if (radio.value !== "false" && radio.checked) {
                            recipientEmailWrapper.classList.add('is-d-none');
                        } else {
                            recipientEmailWrapper.classList.remove('is-d-none');
                        }
                    });
                });
            }

            Array.prototype.forEach.call(navStepBtns, btn => {
                btn.addEventListener('click', () => {
                    if (btn.dataset.targetStep) {
                        const targetStep = Number(btn.dataset.targetStep);
                        const donationTypeValue = typeOfDonationInput.value;
                        if (this.formStep > 1) this.setFormStep(targetId, targetStep, donationTypeValue);
                    }
                });
            });

            if (previousStepBtns.length > 0) {
                Array.prototype.forEach.call(previousStepBtns, previousStepBtn => {
                    const fn = () => {
                        console.log('prev');
                        const donationTypeValue = typeOfDonationInput.value;
                        if (this.formStep >= this.totalSteps) {
                            this.setFormStep(targetId, this.formStep - 2, donationTypeValue);
                        } else if (this.formStep > 1) {
                            this.setFormStep(targetId, this.formStep - 1, donationTypeValue);
                        }
                    }

                    if (!previousStepBtn.classList.contains('hasPrevListener')) {
                        previousStepBtn.addEventListener('click', fn);
                        previousStepBtn.classList.add('hasPrevListener');
                    }
                });
            }

            orgCopyDetailsInput.addEventListener('change', () => {
                this.handleOrgUseContactForCardDetails(orgCopyDetailsInput.checked, form);
                //todo: perhaps make this work in 'real-time' i.e. when contact details are changed, then sync
            });

            const giftAid: HTMLInputElement = form.querySelector('[name="giftaid"]');
            const giftAidMoreInfoButton: HTMLInputElement = form.querySelector('.giftaid-more-info-button');

            if (giftAid) {
                giftAid.addEventListener('change', () => {
                    if (giftAid.checked) {
                        this.toggleMoreInfoButton(form, true);
                        this.toggleMoreInfo(form, false);
                    } else {
                        this.toggleMoreInfoButton(form, false);
                        this.toggleMoreInfo(form, true);
                    }
                });
            }

            if (giftAidMoreInfoButton) {
                giftAidMoreInfoButton.addEventListener('click', () => {
                    this.toggleMoreInfoButton(form, false);
                    this.toggleMoreInfo(form, true);
                });
            }
        }
    }

    toggleMoreInfoButton = (form: HTMLElement, show: boolean) => {
        const giftAidMoreInfoButton: HTMLInputElement = form.querySelector('.giftaid-more-info-button');

        if (giftAidMoreInfoButton) {
            if (show) {
                giftAidMoreInfoButton.removeAttribute('hidden');
            } else {
                giftAidMoreInfoButton.setAttribute('hidden', 'true');
            }
        }
    }

    toggleMoreInfo = (form: HTMLElement, show: boolean) => {
        const giftAidMoreInfo: HTMLInputElement = form.querySelector('.giftaid-more-info');

        if (giftAidMoreInfo) {
            if (show) {
                giftAidMoreInfo.removeAttribute('hidden');
            } else {
                giftAidMoreInfo.setAttribute('hidden', 'true');
            }
        }
    }

    toTitleCase(str) {
        return str.toLowerCase().split(' ').map(function (word) {
            return (word.charAt(0).toUpperCase() + word.slice(1));
        }).join(' ');
    }

    setGiftAidMessage = (loqateLookup = false) => {
        const giftAidEl = this.form.querySelector('.gift-aid-container');
        const giftAidCheckBox = giftAidEl.querySelector('input');
        const notGbMessage = this.form.querySelector('.not-gb-message');
        const notGbAndNotBusinessMessage = this.form.querySelector('.not-gb-and-not-business-message');
        const loqateBusinessAddressMessage = this.form.querySelector('.address-lookup-business-message');
        const giftAidMessages = document.querySelectorAll(".gift-aid-message");

        //Reset Gift Aid visibility and message
        //console.log("Clear gift aid messages");
        giftAidCheckBox.checked = false;

        if (this.donationType === "personal") {
            giftAidEl.classList.add('is-d-block');
            giftAidEl.classList.remove('is-d-none');
        }

        Array.from(giftAidMessages).forEach((el) => {
            el.classList.add("is-d-none");
            el.classList.remove("is-d-block");
        });

        //Loqate check for business address
        if (loqateLookup === true && this.donationType === "personal") {
            giftAidCheckBox.checked = false;
            giftAidEl.classList.remove('is-d-block');
            giftAidEl.classList.add('is-d-none');
            loqateBusinessAddressMessage.classList.remove('is-d-none');
            loqateBusinessAddressMessage.classList.add('is-d-block');
            //console.log("Loqate says this is a business address")
        } else {
            if (this.donationType === "org" || this.donationType === "collection" || this.countryCode !== "GB") {
                //Business donation AND not in the UK
                if (this.donationType === "org" && this.countryCode !== "GB") {
                    giftAidCheckBox.checked = false;
                    giftAidEl.classList.remove('is-d-block');
                    giftAidEl.classList.add('is-d-none');

                    // no point in showing warning as it's an org donation anyway
                    notGbAndNotBusinessMessage.classList.add('is-d-none');
                    notGbAndNotBusinessMessage.classList.remove('is-d-block');

                    console.log("Business donation AND not in the UK")
                }

                else if (this.donationType === "collection" && this.countryCode !== "GB") {
                    giftAidCheckBox.checked = false;
                    giftAidEl.classList.remove('is-d-block');
                    giftAidEl.classList.add('is-d-none');

                    // no point in showing warning as it's an org donation anyway
                    notGbAndNotBusinessMessage.classList.add('is-d-none');
                    notGbAndNotBusinessMessage.classList.remove('is-d-block');

                    console.log("Business donation AND not in the UK")
                }

                else {
                    //Personal donation but not in the UK
                    if (this.countryCode !== "GB") {
                        giftAidCheckBox.checked = false;

                        //No, we still need to show these, but with the prompt
                        // Non residents can still gift aid as long as they
                        // are UK taxpayers

                        //giftAidEl.classList.remove('is-d-block');
                        //giftAidEl.classList.add('is-d-none');
                        notGbMessage.classList.remove('is-d-none');
                        notGbMessage.classList.add('is-d-block');
                        //console.log("Personal donation but not in the UK")
                    }
                }
            }
        }
    }

    handleOrgUseContactForCardDetails(shouldDuplicateDetails: boolean, form) {
        const orgCardHolderTitle: HTMLSelectElement = form.querySelector('[name="orgCardHolderTitle"]');
        const orgCardHolderFirstName: HTMLInputElement = form.querySelector('[name="orgCardHolderFirstName"]');
        const orgCardHolderLastName: HTMLInputElement = form.querySelector('[name="orgCardHolderLastName"]');
        const orgCardHolderEmailAddress: HTMLInputElement = form.querySelector('[name="orgCardHolderEmailAddress"]');
        const orgCardHolderPostalCode: HTMLInputElement = form.querySelector('[name="orgCardHolderPostalCode"]');
        const orgCardHolderAddressLine1: HTMLInputElement = form.querySelector('[name="orgCardHolderAddressLine1"]');
        const orgCardHolderAddressLine2: HTMLInputElement = form.querySelector('[name="orgCardHolderAddressLine2"]');
        const orgCardHolderAddressLine3: HTMLInputElement = form.querySelector('[name="orgCardHolderAddressLine3"]');
        const orgCardHolderCity: HTMLInputElement = form.querySelector('[name="orgCardHolderCity"]');

        const contactTitle: HTMLSelectElement = form.querySelector('[name="title"]');
        const contactFirstName: HTMLInputElement = form.querySelector('[name="firstName"]');
        const contactLastName: HTMLInputElement = form.querySelector('[name="lastName"]');
        const contactEmailAddress: HTMLInputElement = form.querySelector('[name="emailAddress"]');
        const contactPostalCode: HTMLInputElement = form.querySelector('[name="postalCode"]');
        const contactAddressLine1: HTMLInputElement = form.querySelector('[name="addressLine1"]');
        const contactAddressLine2: HTMLInputElement = form.querySelector('[name="addressLine2"]');
        const contactAddressLine3: HTMLInputElement = form.querySelector('[name="addressLine3"]');
        const contactCity: HTMLInputElement = form.querySelector('[name="city"]');
        const orgCardHolderAddressRevealWrapper: HTMLElement = orgCardHolderAddressLine1.closest('.reveal-content');
        const orgCardHolderDetailslWrapper: HTMLElement = form.querySelector('.orgCardHolderDetails');

        if (shouldDuplicateDetails) {
            //copy the data from the contact details
            orgCardHolderDetailslWrapper.classList.add('is-d-none')
            const selectedTitle = contactTitle.value;
            Array.apply(orgCardHolderTitle.selectedOptions, (opt: HTMLOptionElement) => {
                opt.selected = false;
            });

            const matchingOption: HTMLOptionElement = orgCardHolderTitle.querySelector(`option[value="${selectedTitle}"]`);
            matchingOption.selected = true;

            orgCardHolderFirstName.value = contactFirstName.value;
            orgCardHolderLastName.value = contactLastName.value;
            orgCardHolderEmailAddress.value = contactEmailAddress.value;
            orgCardHolderPostalCode.value = contactPostalCode.value;
            orgCardHolderAddressLine1.value = contactAddressLine1.value;
            orgCardHolderAddressLine2.value = contactAddressLine2.value;
            orgCardHolderAddressLine3.value = contactAddressLine3.value;
            orgCardHolderCity.value = contactCity.value;
            orgCardHolderAddressRevealWrapper.classList.remove('is-d-none');

            //disable the fields (or make read-only)
            orgCardHolderFirstName.readOnly = true;
            orgCardHolderLastName.readOnly = true;
            orgCardHolderEmailAddress.readOnly = true;
            orgCardHolderPostalCode.readOnly = true;
            orgCardHolderAddressLine1.readOnly = true;
            orgCardHolderAddressLine2.readOnly = true;
            orgCardHolderAddressLine3.readOnly = true;
            orgCardHolderCity.readOnly = true;

        } else {
            orgCardHolderDetailslWrapper.classList.remove('is-d-none')
            //enable the fields (or make read-write)
            orgCardHolderFirstName.readOnly = false;
            orgCardHolderLastName.readOnly = false;
            orgCardHolderEmailAddress.readOnly = false;
            orgCardHolderPostalCode.readOnly = false;
            orgCardHolderAddressLine1.readOnly = false;
            orgCardHolderAddressLine2.readOnly = false;
            orgCardHolderAddressLine3.readOnly = false;
            orgCardHolderCity.readOnly = false;
        }
    }

    // populate the donation amount, gift amount and giftaid amount into the form

    updateFormDonationAmounts(form) {
        const formStepAmountWrappers = form.querySelectorAll('.donation-amount-details');
        const giftAidEl = form.querySelector('.gift-aid-block');
        const amountInputEle = form.querySelector('[name="amount"]') as HTMLInputElement;

        Array.prototype.forEach.call(formStepAmountWrappers, amountWrapper => {
            const donationAmountEl = amountWrapper.querySelector('.donation-amount');
            const giftAmountEl = amountWrapper.querySelector('.gift-amount');
            console.log(this.donationAmount.toFixed(2), 'donation amount in update form')
            donationAmountEl.textContent = this.donationAmount.toFixed(2);
            giftAmountEl.textContent = (this.giftAmount === "0") ? `` : `${this.giftAmount}`;

            if (this.splitPayment) {
                const donationSplitAmountEl = amountWrapper.querySelector('.donation-split-amount');
                if (donationSplitAmountEl) {
                    donationSplitAmountEl.textContent = this.totalSplitPaymentAmount;
                }
            }
        });

        if (giftAidEl !== null) {
            const giftAidAmountEl = giftAidEl.querySelector('.gift-aid-amount');
            if (giftAidAmountEl) {
                giftAidAmountEl.textContent = this.giftAidAmount.toFixed(2);
            }

            const giftAidIncreaseEl = giftAidEl.querySelector('.gift-aid-increase');
            if (giftAidIncreaseEl) {
                giftAidIncreaseEl.textContent = this.giftAidIncrease.toFixed(2);
            }
        }

        if (amountInputEle !== null) {
            amountInputEle.value = this.donationAmount.toFixed(2);
        }

        if (form.dataset.isSplitPayment !== undefined) {
            const inputIsSplitPayment = form.querySelector("[name='IsSplitPayment']");
            const inputIsRecurringPayment = form.querySelector("[name='IsRecurringPayment']");
            const inputTotalSplitPaymentAmount = form.querySelector("[name='TotalSplitPaymentAmount']");

            inputIsSplitPayment.value = this.splitPayment;
            inputIsRecurringPayment.value = this.splitPayment;
            inputTotalSplitPaymentAmount.value = this.totalSplitPaymentAmount;
        }
    }

    resetFormContent() {

        const typeOfDonationInput: HTMLInputElement = this.formStep1.querySelector('[name="donationType"]');

        if (typeOfDonationInput.value === "org") {
            Array.prototype.forEach.call(this.stepNavs, stepNav => {
                const detailsStep = stepNav.querySelectorAll('li')[0];
                const previousStepCta = detailsStep.querySelector('.previous-step');
                const stepText = "1. Organisation details";

                if (previousStepCta !== null) {
                    previousStepCta.textContent = stepText;
                } else {
                    detailsStep.textContent = stepText;
                }
            });

            if (this.formStep1) {
                this.formStep1.querySelector('.org-title').classList.remove('is-d-none');
                this.formStep1.querySelector('.org-details').classList.remove('is-d-none');
                Array.prototype.forEach.call(this.formStep1.querySelectorAll('.org-field'), field => {
                    field.classList.remove('is-d-none');
                });
            }
            else {
                this.form.querySelector('.org-title').classList.remove('is-d-none');
                this.form.querySelector('.org-details').classList.remove('is-d-none');
                Array.prototype.forEach.call(this.form.querySelectorAll('.org-field'), field => {
                    field.classList.remove('is-d-none');
                });
            }

        }

        else {


            Array.prototype.forEach.call(this.stepNavs, stepNav => {
                const detailsStep = stepNav.querySelectorAll('li')[0];
                const navStepCta = detailsStep.querySelector('.nav-step-cta');
                const stepText = "1. Personal details";

                if (navStepCta !== null) {
                    navStepCta.textContent = stepText;
                } else {
                    detailsStep.textContent = stepText;
                }
            });

            if (this.formStep1) {
                this.formStep1.querySelector('.org-title').classList.add('is-d-none');
                this.formStep1.querySelector('.org-details').classList.add('is-d-none');
                Array.prototype.forEach.call(this.formStep1.querySelectorAll('.org-field'), field => {
                    field.classList.add('is-d-none');
                });
            } else {
                this.form.querySelector('.org-title').classList.add('is-d-none');
                this.form.querySelector('.org-details').classList.add('is-d-none');
                Array.prototype.forEach.call(this.form.querySelectorAll('.org-field'), field => {
                    field.classList.add('is-d-none');
                });
            }

        }

    }

    setFormStep(targetId, step, donationTypeValue) {

        const formContainer = document.querySelector(`#${targetId}`);
        const form = formContainer.querySelector('form');
        if (step > this.totalSteps) {
            step = this.totalSteps;
        }

        this.formStep = step;

        if (this.worldPayLibraryObject && this.worldPayIframeContainer) {
            this.worldPayLibraryObject.destroy();
            this.worldPayIframeContainer.innerHTML = '';
        }

        //console.log('formstep', this.formStep);
        //console.log('totalsteps', this.totalSteps);
        //console.log('isBraintreeForm', this.isBraintreeForm);

        if (this.formStep < this.totalSteps) {

            // Paypal/Braintree implementation
            if (this.formStep + 1 == this.totalSteps) {

                this.updateGoogleAnalyticsCart(this.gaVars, this.donationAmount, 'begin_checkout');

                if (this.isBraintreeForm || this.worldPayIframeContainer) {
                    this.submitForPayment(form);
                    return;
                }
            }

            for (let i = 1; i <= this.totalSteps; i++) {
                const stepEle = document.querySelector(`[data-modal=${targetId + i}]`)
                if (stepEle) {
                    this.modal.hide(`${targetId + i}`, true);
                }
            }

            this.modal.show(targetId, true, this.formStep);
            Array.prototype.forEach.call(document.querySelectorAll('.common-error-container'), ele => {
                ele.classList.add('is-d-none')
            });

        }
        else {
            this.setFinalNavStep();

            // Worldpay implementation
            if (donationTypeValue !== "regular") {
                this.submitForPayment(form);
            }
        }
    }

    pushToDataLayer() {
        const stepTitle = this.modal.getActiveStepTitle();

        if ((<any>window).dataLayer) {
            (<any>window).dataLayer.push({
                event: 'pageview',
                page: {
                    path: `/virtual-pageview/donate-modal/step/${this.formStep}`,
                    title: stepTitle
                }
            });
        }
    }

    hideValidationMessages(inputs) {
        Array.prototype.forEach.call(inputs, input => {
            const messageWrapper = input.closest('.input-wrapper') !== null ?
                input.closest('.input-wrapper').querySelector('.validate-error') :
                input.closest('.select-wrapper').querySelector('.validate-error');
            input.classList.remove('invalid');
            input.classList.add('valid');
            messageWrapper.classList.add('is-d-none');
        });
    }

    scrollFormBackToTop(form) {
        const scrollableContentAreas = form.querySelectorAll('.acc-modal-content');

        Array.prototype.forEach.call(scrollableContentAreas, scrollableContent => {
            scrollableContent.scrollTo({
                top: 0,
                left: 0,
                behavior: 'auto'
            });
        });
    }

    resetForm(form) {
        this.formStep = 1;
        this.scrollFormBackToTop(form);
        this.resetFormContent();
        form.reset();
        this.hideValidationMessages(this.requiredInputs);

        console.log(this.worldPayLibraryObject);

        if (this.worldPayLibraryObject && this.worldPayIframeContainer) {
            this.worldPayLibraryObject.destroy();
            this.worldPayIframeContainer.innerHTML = '';
        }

        if (this.worldPayContainer)
            this.worldPayContainer.innerHTML = '';
        //document.querySelector('.common-error-container').classList.add('is-d-none');
        Array.prototype.forEach.call(document.querySelectorAll('.common-error-container'), ele => {
            ele.classList.add('is-d-none');
        });

    }

    setFinalNavStep() {
        const finalNavEl = this.stepNavs[this.stepNavs.length - 1];
        if (finalNavEl) {
            const navStepEls = finalNavEl.querySelectorAll('li');
            const finalNavStepEl = navStepEls[navStepEls.length - 1];
            const previouslyActiveSteps = finalNavEl.querySelectorAll('.is-active');

            Array.prototype.forEach.call(previouslyActiveSteps, step => {
                step.classList.remove('is-active');
            });
            finalNavStepEl.classList.add('is-active');
        }
    }

    setDirectDebitFinalStep(form) {
        //console.log('starting setDirectDebitFinalStep')
        //window.location.href = '/umbraco/Surface/PaymentSurface/HandleDirectDebit';
        //return Json(new { result = "Redirect", url = Url.Action("ActionName", "ControllerName") });
        //window.location.href = "/{controller}/{action}/{params}";
        const formData = this.serialize(form);
        const wpSubmitDirectDebit = {
            url: '/umbraco/Surface/PaymentSurface/HandleModalDirectDebitAync',
            method: 'POST',
            headers: {
                'content-type': 'application/x-www-form-urlencoded'
            },
            data: formData
        };

        //axios(wpSubmitDirectDebit);

        axios(wpSubmitDirectDebit).then(response => {
            const jsonData = response.data;

            if (!jsonData.success) {
                console.log('no success')
            }
            else {
                if (jsonData.url) {
                    window.location.href = jsonData.url;
                } else {
                    console.log('error')

                }
            }
        });
    }

    public submitForPayment(form) {

        if (!this.isBraintreeForm && !this.worldPayIframeContainer) {
            Array.prototype.forEach.call(document.querySelectorAll('[data-is-payment]'), ele => {
                ele.disabled = true;
            });
        }

        const formData = this.serialize(form);

        if (this.worldPayContainer)
            this.worldPayContainer.innerHTML = '';

        Array.prototype.forEach.call(document.querySelectorAll('.common-error-container'), ele => {
            ele.classList.add('is-d-none')
        });


        document.body.classList.add('wp-launching');

        const wpSubmitOptions = {
            url: '/umbraco/Surface/PaymentSurface/HandleModalDonationAync',
            method: 'POST',
            headers: {
                'content-type': 'application/x-www-form-urlencoded'
            },
            data: formData
        };

        axios(wpSubmitOptions).then(response => {
            const jsonData = response.data;

            //console.log('jsonData:', jsonData);

            if (!this.isBraintreeForm) {
                document.body.classList.remove('wp-launching');

                if (this.worldPayIframeContainer)
                    this.initWorldpayPaymentIframe(form, jsonData);
                else
                    this.initWorldpayPayment(form, jsonData);
            }
            else {
                this.initBraintreePayment(form, jsonData);
            }

        });
    }

    /// WORLDPAY PAYMENT CALLBACK
    public initWorldpayPayment(form, jsonData) {

        const libraryObject = new (<any>window).WPCL.Library();
        const _this = this;


        //console.log('jsonData', jsonData);

        var recapchaError = form.getElementsByClassName('g-recaptcha-error');
        if (recapchaError != null && recapchaError.length > 0) {
            var recapchaTarget = recapchaError[0].querySelector('strong')
            recapchaTarget.innerHTML = '';
        }

        if (!jsonData.success) {
            if (jsonData.url) {
                window.location.href = jsonData.url;
            } else {

                document.body.classList.remove('wp-launching');

                if (jsonData.recapchaSpam != null) {
                    recapchaTarget.innerHTML = 'Verification failed, please try again';
                    console.log('recapcha error');
                    var grecaptcha = window.grecaptcha;
                    grecaptcha.reset();

                    Array.prototype.forEach.call(document.querySelectorAll('[data-is-payment]'), ele => {
                        ele.disabled = false;
                    });
                    return;
                }
                else {

                    document.querySelector('aside.is-active .common-error-container').classList.remove('is-d-none');
                    this.worldPayContainer.innerHTML = '';

                    Array.prototype.forEach.call(document.querySelectorAll('[data-is-payment]'), ele => {
                        ele.disabled = false;

                        console.log("Error message:" + jsonData.errorMsg);
                    });
                }
            }
        }
        else {
            if (jsonData.IsAPM) {
                window.location.href = jsonData.url;
            }
            else {
                // Using direct WP url instead of widget for mobile devices
                if (_this.isMobileDevice) {
                    var redirUrl = jsonData.url;
                    redirUrl += '&successURL=' + encodeURIComponent(jsonData.successUrl);
                    redirUrl += '&failureURL=' + encodeURIComponent(jsonData.failureUrl);
                    redirUrl += '&errorURL=' + encodeURIComponent(jsonData.errorUrl);
                    redirUrl += '&cancelURL=' + encodeURIComponent((<any>window).Crisis.util.getAbsoluteUrl(window.location.href.split('#')[0]));
                    redirUrl += '&pendingURL=' + encodeURIComponent(jsonData.cancelUrl);


                    window.location.href = redirUrl;
                }
                else {

                    const wpCustomOptions = {
                        iframeIntegrationId: 'libraryObject',
                        iframeHelperURL: (<any>window).Crisis.util.getAbsoluteUrl('/wp-helper.html'),
                        iframeBaseURL: (<any>window).Crisis.util.getAbsoluteUrl('/'),
                        type: 'lightbox',
                        trigger: 'lbtrigger',
                        target: 'wp-container',
                        accessibility: true,
                        debug: false,
                        language: 'en',
                        country: 'gb',
                        preferredPaymentMethod: '',
                        url: jsonData.url,
                        successURL: jsonData.successUrl,
                        failureURL: jsonData.failureUrl,
                        errorURL: jsonData.errorUrl,
                        resultCallback: function (response) {
                            if (response.order.status === 'cancelled_by_shopper') {
                                _this.worldPayContainer.innerHTML = '';
                            }

                            Array.prototype.forEach.call(document.querySelectorAll('[data-is-payment]'), ele => {
                                ele.disabled = false;
                            });
                        }
                    };

                    if (libraryObject) {
                        libraryObject.setup(wpCustomOptions);
                        const evt = document.createEvent('Event');
                        evt.initEvent('load', false, true);
                        window.dispatchEvent(evt);

                        const lbl = document.getElementById('lbtrigger');
                        const evt2 = document.createEvent('Event');
                        evt2.initEvent('click', false, true);
                        lbl.dispatchEvent(evt2);
                    }
                }
            }
        }
    }

    public initWorldpayPaymentIframe(form, jsonData) {

        //const libraryObject = new (<any>window).WPCL.Library();
        const formContainer = form.closest('.acc-donation-form-container');
        const targetId = formContainer.id;

        const _this = this;
        _this.worldPayLibraryObject = new (<any>window).WPCL.Library();


        //console.log('jsonData', jsonData);

        var recapchaError = form.getElementsByClassName('g-recaptcha-error');
        if (recapchaError != null && recapchaError.length > 0) {
            var recapchaTarget = recapchaError[0].querySelector('strong')
            recapchaTarget.innerHTML = '';
        }

        if (!jsonData.success) {
            if (jsonData.url) {
                window.location.href = jsonData.url;
            } else {
                // AL 14/11/23 de-increment formstep on WP error
                _this.formStep--;

                document.body.classList.remove('wp-launching');

                if (jsonData.recapchaSpam != null) {

                    recapchaTarget.innerHTML = 'Verification failed, please try again';
                    console.log('recapcha error');
                    var grecaptcha = window.grecaptcha;
                    grecaptcha.reset();

                    Array.prototype.forEach.call(document.querySelectorAll('[data-is-payment]'), ele => {
                        ele.disabled = false;
                    });
                    return;
                }
                else {

                    document.querySelector('aside.is-active .common-error-container').classList.remove('is-d-none');
                    this.worldPayContainer.innerHTML = '';

                    Array.prototype.forEach.call(document.querySelectorAll('[data-is-payment]'), ele => {
                        ele.disabled = false;

                        console.log("Error message:" + jsonData.errorMsg);
                    });
                }
            }
        }
        else {
            if (jsonData.IsAPM) {
                window.location.href = jsonData.url;
            }
            else {
                this.setFinalNavStep();
                for (let i = 1; i <= this.totalSteps; i++) {
                    const stepEle = document.querySelector(`[data-modal=${targetId + i}]`)
                    if (stepEle) {
                        this.modal.hide(`${targetId + i}`, true);
                    }
                }
                this.modal.show(targetId, true, this.formStep);

                const wpCustomOptions = {
                    iframeIntegrationId: 'libraryObject',
                    iframeHelperURL: (<any>window).Crisis.util.getAbsoluteUrl('/wp-helper.html'),
                    iframeBaseURL: (<any>window).Crisis.util.getAbsoluteUrl('/'),
                    disableScrolling: true,
                    type: 'iframe',
                    target: 'wp-iframe-container',
                    inject: 'immediate',
                    accessibility: true,
                    debug: false,
                    language: 'en',
                    country: 'gb',
                    preferredPaymentMethod: '',
                    url: jsonData.url,
                    successURL: jsonData.successUrl,
                    failureURL: jsonData.failureUrl,
                    errorURL: jsonData.errorUrl,
                    resultCallback: function (response) {
                        if (response.order.status === 'cancelled_by_shopper') {
                            _this.modal.hide(targetId + _this.formStep);
                            _this.resetForm(form);
                        }

                        Array.prototype.forEach.call(document.querySelectorAll('[data-is-payment]'), ele => {
                            ele.disabled = false;
                        });
                    }
                };

                if (_this.worldPayLibraryObject) {
                    _this.worldPayLibraryObject.setup(wpCustomOptions);
                }

                //if (_this.isMobileDevice) {
                //    var redirUrl = jsonData.url;
                //    redirUrl += '&successURL=' + encodeURIComponent(jsonData.successUrl);
                //    redirUrl += '&failureURL=' + encodeURIComponent(jsonData.failureUrl);
                //    redirUrl += '&errorURL=' + encodeURIComponent(jsonData.errorUrl);
                //    redirUrl += '&cancelURL=' + encodeURIComponent((<any>window).Crisis.util.getAbsoluteUrl(window.location.href.split('#')[0]));
                //    redirUrl += '&pendingURL=' + encodeURIComponent(jsonData.cancelUrl);


                //    window.location.href = redirUrl;
                //}
                //else {
                //    this.setFinalNavStep();
                //    for (let i = 1; i <= this.totalSteps; i++) {
                //        const stepEle = document.querySelector(`[data-modal=${targetId + i}]`)
                //        if (stepEle) {
                //            this.modal.hide(`${targetId + i}`, true);
                //        }
                //    }

                //    this.modal.show(targetId, true, this.formStep);

                //    const wpCustomOptions = {
                //        iframeIntegrationId: 'libraryObject',
                //        iframeHelperURL: (<any>window).Crisis.util.getAbsoluteUrl('/wp-helper.html'),
                //        iframeBaseURL: (<any>window).Crisis.util.getAbsoluteUrl('/'),
                //        disableScrolling: true,
                //        type: 'iframe',
                //        target: 'wp-iframe-container',
                //        inject: 'immediate',
                //        accessibility: true,
                //        debug: false,
                //        language: 'en',
                //        country: 'gb',
                //        preferredPaymentMethod: '',
                //        url: jsonData.url,
                //        successURL: jsonData.successUrl,
                //        failureURL: jsonData.failureUrl,
                //        errorURL: jsonData.errorUrl,
                //        resultCallback: function (response) {
                //            if (response.order.status === 'cancelled_by_shopper') {

                //                _this.modal.hide(targetId + _this.formStep);
                //                _this.resetForm(form);
                //            }

                //            Array.prototype.forEach.call(document.querySelectorAll('[data-is-payment]'), ele => {
                //                ele.disabled = false;
                //            });
                //        }
                //    };

                //    if (_this.worldPayLibraryObject) {
                //        _this.worldPayLibraryObject.setup(wpCustomOptions);
                //    }
                //}
            }
        }
    }

    // BRAINTREE PAYMENT CALLBACK
    public initBraintreePayment(form, jsonData) {

        const braintreeObj = (<any>window).braintree;
        const googleObj = (<any>window).google;
        const applePaySessionObj = (<any>window).ApplePaySession;
        const formContainer = form.closest('.acc-donation-form-container');
        const targetId = formContainer.id;

        var paymentAmount = parseFloat(form.querySelector('[name="amount"]').value);
        var description = form.querySelector('[name="btree-product-description"]').value;

        var recapchaError = form.getElementsByClassName('g-recaptcha-error');
        var recapchaTarget;
        var deviceData;
        var threeDSecure;

        var _this = this;
        var doTransaction = function (jsonData, payload) {

            //console.log('dt payload:', payload);
            document.body.classList.add('bt-payment-completing');

            const submitOptions = {
                url: '/umbraco/Surface/PaypalBraintreeSurface/DoTransaction',
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                data: {
                    orderId: jsonData.orderId,
                    deviceDataFromTheClient: deviceData,
                    nonceFromTheClient: payload.nonce,
                    productDescription: description
                }
            };

            //console.log('jsonData:', jsonData);
            console.log('submitOptions:', submitOptions);

            axios(submitOptions).then(response => {
                //console.log('dt response:', response);

                if (!response.data.success) {
                    if (response.data.error)
                        console.log('payment error:', response.data.error);

                    document.body.classList.remove('bt-payment-completing');
                    document.querySelector('.btree-error').classList.remove('is-d-none');
                }
                else {
                    window.location.href = response.data.url;
                }

            });
        };

        _this.BraintreeTransactionData = jsonData;
        _this.BraintreeFormSubmitFunction = _this.BraintreeFormSubmitFunction || function (e) {
            e.preventDefault();
            document.body.classList.add('bt-payment-completing');

            _this.BraintreeHostedfieldsInstance.tokenize(function (tokenizeErr, payload) {

                //console.log('payload:', payload);
                var fields = _this.BraintreeHostedfieldsInstance.getState().fields;
                var threeDSecureParameters = {
                    amount: parseFloat(form.querySelector('[name="amount"]').value),
                    bin: (payload && payload.details.bin) ? payload.details.bin : '',
                    collectDeviceData: true,
                    email: form.querySelector('[name="emailAddress"]').value,
                    nonce: (payload && payload.nonce) ? payload.nonce : '',
                    billingAddress: {
                        givenName: form.querySelector('[name="firstName"]').value,
                        surname: form.querySelector('[name="lastName"]').value,
                        phoneNumber: form.querySelector('[name="phoneNumber"]').value,
                        streetAddress: form.querySelector('[name="addressLine1"]').value,
                        extendedAddress: form.querySelector('[name="addressLine2"]').value,
                        postalCode: form.querySelector('[name="postalCode"]').value,
                        countryCodeAlpha2: form.querySelector('[name="CountryCode"]').value
                    },
                    additionalInformation: {
                        ipAddress: (<any>window).Crisis.util.clientInfo.ipAddress
                    },
                    onLookupComplete: function (data, next) {
                        // use `data` here, then call `next()`
                        //console.log('3Ddata:', data);
                        var data = data;
                        next();
                    }
                };

                console.log('threeDSecureParameters', threeDSecureParameters);

                if (tokenizeErr) {
                    console.log('token error:', tokenizeErr);
                    document.body.classList.remove('bt-payment-completing');

                    for (var key in fields) {
                        if (fields.hasOwnProperty(key)) {
                            if (!fields[key].isValid)
                                fields[key].container.classList.add('braintree-hosted-fields-invalid');
                            else
                                fields[key].container.classList.remove('braintree-hosted-fields-invalid');
                        }
                    }

                    if (tokenizeErr.code != 'HOSTED_FIELDS_FIELDS_EMPTY' && tokenizeErr.code != 'HOSTED_FIELDS_FIELDS_INVALID')
                        document.querySelector('.btree-error').classList.remove('is-d-none');

                    return;
                }
                threeDSecure.verifyCard(threeDSecureParameters).then(function (response) {
                    //console.log('3Dresponse:', response);

                    if (!response.rawCardinalSDKVerificationData || response.rawCardinalSDKVerificationData.ActionCode.toLowerCase() == 'success')
                        doTransaction(_this.BraintreeTransactionData, response);
                    else
                        document.body.classList.remove('bt-payment-completing');

                }).catch(function (err) {
                    console.log('threeDSecure error:', err);
                    document.body.classList.remove('bt-payment-completing');
                    document.querySelector('.btree-error').classList.remove('is-d-none');
                });

            });
        };

        if (recapchaError != null && recapchaError.length > 0) {
            recapchaTarget = recapchaError[0].querySelector('strong')
            recapchaTarget.innerHTML = '';
        }

        if (!jsonData.success || !jsonData.orderId) {
            this.formStep--;
            document.body.classList.remove('wp-launching');

            if (jsonData.recapchaSpam != null) {

                recapchaTarget.innerHTML = 'Verification failed, please try again';
                console.log('recapcha error');
                var grecaptcha = window.grecaptcha;
                grecaptcha.reset();

                return;
            }
            else {
                if (jsonData.error)
                    console.log(jsonData.error);

                document.querySelector('aside.is-active .common-error-container').classList.remove('is-d-none');
            }
            Array.prototype.forEach.call(document.querySelectorAll('[data-is-payment]'), ele => {
                //console.log("Show button");
                ele.disabled = false;
            });

        }
        else {

            // reset event listeners and teardown BT instances
            form.removeEventListener('submit', _this.BraintreeFormSubmitFunction, false);
            if (_this.BraintreeHostedfieldsInstance)
                _this.BraintreeHostedfieldsInstance.teardown(function (err) {
                    if (err)
                        console.log('braintree hosted fields teardown error:', err);
                    else
                        _this.BraintreeHostedfieldsInstance = null;
                });
            if (_this.BraintreePaypalCheckoutInstance)
                _this.BraintreePaypalCheckoutInstance.teardown(function (err) {
                    if (err)
                        console.log('braintree paypal checkout teardown error:', err);
                    else
                        _this.BraintreePaypalCheckoutInstance = null;
                });
            if (_this.BraintreeGooglePaymentInstance)
                _this.BraintreeGooglePaymentInstance.teardown(function (err) {
                    if (err)
                        console.log('braintree google pay teardown error:', err);
                    else
                        _this.BraintreeGooglePaymentInstance = null;
                });
            if (_this.BraintreeApplePayInstance)
                _this.BraintreeApplePayInstance.teardown(function (err) {
                    if (err)
                        console.log('braintree google pay teardown error:', err);
                    else
                        _this.BraintreeApplePayInstance = null;
                });

            this.setFinalNavStep();
            for (let i = 1; i <= this.totalSteps; i++) {
                const stepEle = document.querySelector(`[data-modal=${targetId + i}]`)
                if (stepEle) {
                    this.modal.hide(`${targetId + i}`, true);
                }
            }

            this.modal.show(targetId, true, this.formStep);
            //Array.prototype.forEach.call(document.querySelectorAll('.common-error-container'), ele => {
            //    ele.classList.add('is-d-none')
            //});

            ///////////////////////////////////////
            // HOSTED FIELDS CHECKOUT
            braintreeObj.client.create({
                authorization: jsonData.client.clientToken
            }).then(function (clientInstance) {

                braintreeObj.dataCollector.create({
                    client: clientInstance
                }).then(function (dataCollectorInstance) {
                    deviceData = dataCollectorInstance.deviceData;
                });

                var options = {
                    client: clientInstance,
                    styles: {
                        'input': {
                            'color': '#000',
                            'font-family': 'museo-sans, arial, sans serif',
                            'font-size': '16px',
                            'font-weight': '500',
                            'line-height': '1.2em'
                        },
                        'input.invalid': {
                            'color': '#eb2427'
                        },
                        'input.valid': {
                        }
                    },
                    fields: {
                        number: {
                            container: '#btree-card-number',
                            placeholder: ''
                        },
                        cardholderName: {
                            container: '#btree-cardholder-name',
                            placeholder: '',
                            prefill: form.querySelector('[name="firstName"]').value + ' ' + form.querySelector('[name="lastName"]').value
                        },
                        cvv: {
                            container: '#btree-cvv',
                            placeholder: ''
                        },
                        expirationDate: {
                            container: '#btree-expiration-date',
                            placeholder: 'MM/YYYY'
                        }
                    }
                };

                return braintreeObj.hostedFields.create(options);

            }).then(function (hostedFieldsInstance) {

                console.log('hostedFieldsInstance:', hostedFieldsInstance);

                _this.BraintreeHostedfieldsInstance = hostedFieldsInstance;

                // threeDSecure implementation
                braintreeObj.client.create({
                    authorization: jsonData.client.clientToken
                }).then(function (clientInstance) {
                    return braintreeObj.threeDSecure.create({
                        version: 2, // Will use 3DS2 whenever possible
                        client: clientInstance
                    });
                }).then(function (threeDSecureInstance) {
                    threeDSecure = threeDSecureInstance;
                    form.addEventListener('submit', _this.BraintreeFormSubmitFunction, false);

                }).catch(function (err) {
                    console.log('threeDSecure error:', err);
                    document.body.classList.remove('wp-launching');
                    document.querySelector('.btree-error').classList.remove('is-d-none');
                });


                ///////////////////////////////////////
                // PAYPAL CHECKOUT

                braintreeObj.client.create({
                    authorization: jsonData.client.clientToken
                }).then(function (clientInstance) {
                    // Create a PayPal Checkout component
                    return braintreeObj.paypalCheckout.create({
                        client: clientInstance
                    });
                }).then(function (paypalCheckoutInstance) {
                    return paypalCheckoutInstance.loadPayPalSDK({
                        currency: 'GBP',
                        intent: 'capture'
                    });
                }).then(function (paypalCheckoutInstance) {

                    console.log('paypalCheckoutInstance:', paypalCheckoutInstance);

                    _this.BraintreePaypalCheckoutInstance = paypalCheckoutInstance;

                    var paypalObj = (<any>window).paypal;

                    document.body.classList.remove('wp-launching');

                    return paypalObj.Buttons({
                        fundingSource: paypalObj.FUNDING.PAYPAL,
                        style: {
                            height: 50,
                            shape: 'rect',
                            label: 'paypal'
                        },
                        createOrder: function () {

                            return _this.BraintreePaypalCheckoutInstance.createPayment({
                                flow: 'checkout', // Required
                                amount: paymentAmount, // Required
                                currency: 'GBP', // Required, must match the currency passed in with loadPayPalSDK

                                intent: 'capture' // Must match the intent passed in with loadPayPalSDK
                            });
                        },
                        onApprove: function (data, actions) {
                            //console.log(actions);
                            var actions = actions;
                            return _this.BraintreePaypalCheckoutInstance.tokenizePayment(data).then(function (payload) {

                                doTransaction(jsonData, payload);

                            });
                        },
                        onCancel: function (data) {
                            console.log('PayPal payment cancelled:', data);
                        },
                        onError: function (err) {
                            console.error('PayPal error:', err);
                            document.querySelector('.btree-error').classList.remove('is-d-none');
                        }
                    }).render('#btree-paypal-button');

                }).catch(function (err) {
                    // Handle component creation error
                    console.log('paypal checkout error:', err);

                    document.body.classList.remove('wp-launching');

                    document.querySelector('.btree-error').classList.remove('is-d-none');
                });

                ///////////////////////////////////////
                // GOOGLE PAY CHECKOUT
                var googlePayButtonContainer = document.querySelector('#btree-googlepay-button');
                var googlePaymentsClient = new googleObj.payments.api.PaymentsClient({
                    environment: _this.isDevHost ? 'TEST' : 'PRODUCTION'
                });

                googlePayButtonContainer.innerHTML = "";

                braintreeObj.client.create({
                    authorization: jsonData.client.clientToken
                }).then(function (clientInstance) {
                    return braintreeObj.googlePayment.create({
                        client: clientInstance,
                        googlePayVersion: 2,
                        googleMerchantId: 'BCR2DN4TXC66F2YO' // Optional in sandbox; if set in sandbox, this value must be a valid production Google Merchant ID
                    });
                }).then(function (googlePaymentInstance) {

                    _this.BraintreeGooglePaymentInstance = googlePaymentInstance;
                    console.log('googlePaymentInstance:', _this.BraintreeGooglePaymentInstance);

                    return googlePaymentsClient.isReadyToPay({
                        // see https://developers.google.com/pay/api/web/reference/object#IsReadyToPayRequest
                        apiVersion: 2,
                        apiVersionMinor: 0,
                        allowedPaymentMethods: googlePaymentInstance.createPaymentDataRequest().allowedPaymentMethods,
                        existingPaymentMethodRequired: true // Optional
                    });
                }).then(function (response) {
                    if (response.result) {

                        var btn = googlePaymentsClient.createButton({
                            buttonColor: 'default',
                            buttonType: 'plain',
                            buttonSizeMode: 'fill',
                            onClick: (event) => {
                                event.preventDefault();

                                var paymentDataRequest = _this.BraintreeGooglePaymentInstance.createPaymentDataRequest({
                                    transactionInfo: {
                                        currencyCode: 'GBP',
                                        totalPriceStatus: 'FINAL',
                                        totalPrice: paymentAmount.toString() // Your amount
                                    }
                                });

                                // We recommend collecting billing address information, at minimum
                                // billing postal code, and passing that billing postal code with all
                                // Google Pay card transactions as a best practice.
                                // See all available options at https://developers.google.com/pay/api/web/reference/object
                                var cardPaymentMethod = paymentDataRequest.allowedPaymentMethods[0];
                                cardPaymentMethod.parameters.billingAddressRequired = true;
                                cardPaymentMethod.parameters.billingAddressParameters = {
                                    format: 'FULL',
                                    phoneNumberRequired: true
                                };

                                googlePaymentsClient.loadPaymentData(paymentDataRequest).then(function (paymentData) {
                                    return _this.BraintreeGooglePaymentInstance.parseResponse(paymentData);
                                }).then(function (result) {
                                    doTransaction(jsonData, result);
                                }).catch(function (err) {
                                    console.log('google pay checkout error:', err);
                                });
                            }
                        });
                        googlePayButtonContainer.appendChild(btn);
                        googlePayButtonContainer.classList.remove('is-d-none');
                    }
                }).catch(function (err) {
                    googlePayButtonContainer.classList.add('is-d-none');
                    console.log('Google pay create error:', err);
                });

                ///////////////////////////////////////
                // APPLE PAY CHECKOUT
                var applePayButtonContainer = document.querySelector('#btree-apple-pay-button-outer');

                console.log('applePaySessionObj:', applePaySessionObj);

                if (applePaySessionObj && applePaySessionObj.supportsVersion(11) && applePaySessionObj.canMakePayments()) {
                    // This device supports version 3 of Apple Pay.
                    applePayButtonContainer.innerHTML = '<div class="btree-apple-pay-button apple-pay-button-black"></div>';
                    applePayButtonContainer.classList.remove('is-d-none');

                    braintreeObj.client.create({
                        authorization: jsonData.client.clientToken
                    }).then(function (clientInstance) {
                        return braintreeObj.applePay.create({
                            client: clientInstance
                        });
                    }).then(function (applePayInstance) {
                        _this.BraintreeApplePayInstance = applePayInstance;

                        var applePayButton = applePayButtonContainer.querySelector('.btree-apple-pay-button');

                        //console.log('paymentAmount:', paymentAmount);

                        var paymentRequest = _this.BraintreeApplePayInstance.createPaymentRequest({
                            total: {
                                label: 'Crisis UK',
                                amount: paymentAmount.toString(),
                                countryCode: 'GB',
                                currencyCode: 'GBP'
                            },

                            // We recommend collecting billing address information, at minimum
                            // billing postal code, and passing that billing postal code with
                            // all Apple Pay transactions as a best practice.
                            requiredBillingContactFields: ["postalAddress"]
                        });

                        //console.log(paymentRequest.countryCode);
                        //console.log(paymentRequest.currencyCode);
                        //console.log(paymentRequest.merchantCapabilities);
                        //console.log(paymentRequest.supportedNetworks);

                        applePayButton.addEventListener('click', function (e) {
                            e.preventDefault();

                            //console.log('paymentRequest:', paymentRequest);
                            //console.log('jsonData:', jsonData);

                            var session = new applePaySessionObj(3, paymentRequest);
                            session.onvalidatemerchant = function (event) {
                                _this.BraintreeApplePayInstance.performValidation({
                                    validationURL: event.validationURL,
                                    displayName: 'My Store'
                                }).then(function (merchantSession) {
                                    session.completeMerchantValidation(merchantSession);
                                }).catch(function (validationErr) {
                                    // You should show an error to the user, e.g. 'Apple Pay failed to load.'
                                    console.error('Apple pay mechant validation error:', validationErr);
                                    session.abort();
                                });
                            };
                            session.onpaymentauthorized = function (event) {

                                _this.BraintreeApplePayInstance.tokenize({
                                    token: event.payment.token
                                }).then(function (payload) {

                                    session.completePayment(applePaySessionObj.STATUS_SUCCESS);
                                    doTransaction(jsonData, payload);

                                }).catch(function (tokenizeErr) {
                                    console.error('Apple pay tokenisation error:', tokenizeErr);
                                    session.completePayment(applePaySessionObj.STATUS_FAILURE);
                                });
                            };
                            session.begin();
                        }, { once: true });

                    }).catch(function (err) {
                        applePayButtonContainer.classList.add('is-d-none');
                        console.log('Apple pay create error:', err);
                    });

                }
                else {
                    applePayButtonContainer.classList.add('is-d-none');
                    console.log('Apple pay not supported');
                }

            }).catch(function (err) {
                // Handle error in component creation
                console.log('hosted fields error:', err);

                document.body.classList.remove('wp-launching');

                document.querySelector('.btree-error').classList.remove('is-d-none');
            });

        }
    }

    serialize(form) {

        // Setup our serialized data
        const serialized = [];

        // Loop through each field in the form
        for (let i = 0; i < form.elements.length; i++) {

            const field = form.elements[i];

            // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
            if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

            // If a multi-select, get all selections
            if (field.type === 'select-multiple') {
                for (let n = 0; n < field.options.length; n++) {
                    if (!field.options[n].selected) continue;
                    serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
                }
            }

            // Convert field data to a query string
            else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
                serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
            }
        }

        return serialized.join('&');

    }

    // loadCaptcha(){

    //        const existingScript = document.getElementById('googleCaptchaScript');

    //    if (!existingScript) {
    //            const script = document.createElement('script');
    //            script.src = 'https://www.google.com/recaptcha/api.js'; // URL for the third-party library being loaded.
    //            script.id = 'googleCaptchaScript'; // e.g., googleMaps or stripe
    //            document.body.appendChild(script);

    //        var gcr = this.captchaReady;
    //        script.addEventListener('load', function() {
    //            console.log("gcloaded");
    //            gcr.value = true;
    //        });


    //    if (existingScript) this.captchaReady.value = true;
    //     };


    //}


}

export default new DonationForm();